const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Extract an order uuid from a scanned QR payload or deep-link URL. */
export function parseOrderIdFromScanPayload(raw: string): string | null {
  const text = raw.trim();
  if (!text) return null;
  if (UUID_RE.test(text)) return text;

  try {
    const url = new URL(text);
    for (const key of ["o", "order"]) {
      const v = url.searchParams.get(key);
      if (v && UUID_RE.test(v)) return v;
    }
  } catch {
    // Not a URL — fall through to regex.
  }

  const match = text.match(/[?&](?:o|order)=([0-9a-f-]{36})/i);
  return match?.[1] && UUID_RE.test(match[1]) ? match[1] : null;
}

export function orderManagementScanPath(orderId: string): string {
  return `/pro/admin?tab=order-management&order=${encodeURIComponent(orderId)}&scan=1`;
}

/** Navigate a Capacitor universal-link or custom-scheme URL into the SPA. */
export function spaPathFromDeepLink(url: string): string | null {
  try {
    const u = new URL(url);
    if (!u.hostname.endsWith("golfauth.com")) return null;
    return `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return null;
  }
}
